import React, { useState } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Dropdown,
  Button,
  Tag,
  Divider,
} from "antd";

import {
  PlusOutlined,
  DownOutlined,
  AppstoreOutlined,
  BookOutlined,
  ApartmentOutlined,
  TeamOutlined,
  SafetyCertificateOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
  FileSearchOutlined,
  ReadOutlined,
  ClockCircleOutlined,
  SolutionOutlined,
  TrophyOutlined,
  AuditOutlined,
  ArrowRightOutlined,
  FlagOutlined,
  BankOutlined,
} from "@ant-design/icons";

import { motion } from "framer-motion";





import AddClass from "../../pages/Students/AddClass";
import SubjectFormModal from "../../SchoolDashApp/Class/Subjects/SubjectFormModal";
import DivisionFormModal from "../../SchoolDashApp/Division/DivisionFormModal";

import ProfileImageDashboard from "../ProfileImageDashboard";


const { Title, Text, Paragraph } = Typography;

const COLORS = {
  navy: "#062A4B",
  navyDeep: "#041C33",
  blue: "#0F5687",
  gold: "#C99A35",
  goldLight: "#F8F0DD",
  goldPale: "#FCF9F2",
  white: "#FFFFFF",
  text: "#172B40",
  muted: "#708094",
  border: "#E5EAF0",
  green: "#26815E",
  greenPale: "#EAF6EF",
  bluePale: "#EDF5FC",
  purple: "#7560A8",
  purplePale: "#F2EFFA",
  orange: "#C0750D",
  orangePale: "#FFF4E5",
};

const responsibilities = [
  {
    number: "01",
    title: "Academic Supervision",
    description:
      "Monitor classroom instruction, curriculum coverage, lesson preparation, and teaching effectiveness.",
    icon: <ReadOutlined />,
    color: COLORS.blue,
    background: COLORS.bluePale,
  },
  {
    number: "02",
    title: "Teacher Performance",
    description:
      "Support teachers, review professional conduct, coordinate observations, and encourage continuous improvement.",
    icon: <TeamOutlined />,
    color: COLORS.purple,
    background: COLORS.purplePale,
  },
  {
    number: "03",
    title: "Student Discipline",
    description:
      "Promote positive behavior, address disciplinary concerns fairly, and maintain a safe learning environment.",
    icon: <SafetyCertificateOutlined />,
    color: COLORS.green,
    background: COLORS.greenPale,
  },
  {
    number: "04",
    title: "Attendance & Punctuality",
    description:
      "Follow up on student and staff attendance concerns and help maintain punctuality throughout the school.",
    icon: <ClockCircleOutlined />,
    color: COLORS.orange,
    background: COLORS.orangePale,
  },
  {
    number: "05",
    title: "Academic Records",
    description:
      "Review assessment progress, examination readiness, academic reports, and outstanding instructional records.",
    icon: <FileSearchOutlined />,
    color: COLORS.blue,
    background: COLORS.bluePale,
  },
  {
    number: "06",
    title: "School Operations",
    description:
      "Coordinate daily activities, communicate with the Principal, and follow up on assigned institutional duties.",
    icon: <AuditOutlined />,
    color: COLORS.gold,
    background: COLORS.goldPale,
  },
];

const dailyPriorities = [
  "Review staff and student attendance.",
  "Follow up on classroom teaching and lesson delivery.",
  "Address student discipline and welfare concerns.",
  "Check academic tasks, assessments, and pending reports.",
  "Record important incidents and actions taken.",
  "Prepare an update for the Principal when necessary.",
];

const OverviewVpi = ({ theme = {} }) => {
  const [openAddClass, setOpenAddClass] = useState(false);
  const [openSubjectModal, setOpenSubjectModal] = useState(false);
  const [openDivisionModal, setOpenDivisionModal] = useState(false);

  const isDark = theme.mode === "dark";

  const pageTheme = {
    card: theme.card || (isDark ? "#142335" : COLORS.white),
    text: theme.text || (isDark ? "#F0F4FA" : COLORS.text),
    secondary: theme.secondary || COLORS.muted,
    border: theme.border || (isDark ? "#2B3C50" : COLORS.border),
    background: isDark ? "#0B1624" : "#F5F7FA",
  };

  const triggerAcademicCountUpdate = () => {
    window.dispatchEvent(new Event("academicCountUpdated"));
  };

  const addMenu = {
    items: [
      {
        key: "class",
        label: "Add Grade Class",
        icon: <AppstoreOutlined />,
      },
      {
        key: "subject",
        label: "Add Subject",
        icon: <BookOutlined />,
      },
      {
        key: "division",
        label: "Add Division",
        icon: <ApartmentOutlined />,
      },
    ],
    onClick: ({ key }) => {
      if (key === "class") setOpenAddClass(true);
      if (key === "subject") setOpenSubjectModal(true);
      if (key === "division") setOpenDivisionModal(true);
    },
  };

  const sectionHeading = (eyebrow, heading, icon, iconColor) => (
    <div className="vpi-section-header">
      <div style={{ minWidth: 0 }}>
        <Text className="vpi-section-eyebrow">{eyebrow}</Text>
        <Title level={4} className="vpi-section-title">
          {heading}
        </Title>
      </div>

      <div
        className="vpi-section-icon"
        style={{
          color: iconColor,
          background: `${iconColor}12`,
        }}
      >
        {icon}
      </div>
    </div>
  );

  return (
    <div
      className={`vpi-dashboard ${isDark ? "vpi-dark" : ""}`}
      style={{
        width: "100%",
        maxWidth: 1800,
        margin: "0 auto",
        padding: "0 2px 24px",
        boxSizing: "border-box",
        color: pageTheme.text,
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35 }}
      >
        {/* =====================================================
            LEADERSHIP HEADER
        ====================================================== */}

        <Card
          className="vpi-main-card"
          bordered={false}
          styles={{ body: { padding: 0 } }}
          style={{
            background: pageTheme.card,
            border: `1px solid ${pageTheme.border}`,
          }}
        >

               <div>
              <div className="vpi-profile">
                <ProfileImageDashboard theme={theme} overview />
              </div>
            </div>
            <br/>
          <div className="vpi-header">
            <div className="vpi-header-decoration vpi-decoration-one" />
            <div className="vpi-header-decoration vpi-decoration-two" />

         

            <div className="vpi-header-top">
         

              <div className="vpi-heading">
                <div className="vpi-eyebrow">
                  <BankOutlined />
                  <span>School Leadership & Administration</span>
                </div>

                <Title level={2} className="vpi-title">
                  Vice Principal's Office
                </Title>

                <Paragraph className="vpi-subtitle">
                  Your workspace for academic supervision, student
                  welfare, staff coordination, and effective school
                  operations.
                </Paragraph>

                <div className="vpi-leadership-tags">
                  <Tag className="vpi-role-tag">
                    <SolutionOutlined /> VICE PRINCIPAL
                  </Tag>

                  <Tag className="vpi-office-tag">
                    Academic & Operational Oversight
                  </Tag>
                </div>
              </div>
            </div>

  
          </div>

          <div className="vpi-header-footer">
            <div className="vpi-footer-message">
              <span className="vpi-footer-icon">
                <FlagOutlined />
              </span>
              <span>
                <strong>Leadership objective</strong>
                <span>
                  Maintain high academic standards, accountability,
                  discipline, and a supportive learning environment.
                </span>
              </span>
            </div>

            <div className="vpi-footer-mark">
              <TrophyOutlined />
              <span>Excellence Through Leadership</span>
            </div>
          </div>
        </Card>

        {/* =====================================================
            SCHOOL OVERVIEW
        ====================================================== */}

        <div className="vpi-block-heading">
          <div>
            <Text className="vpi-section-eyebrow">
              INSTITUTIONAL SNAPSHOT
            </Text>
            <Title level={4} className="vpi-block-title">
              School Overview
            </Title>
          </div>

          <Text className="vpi-block-caption">
            Key figures for the selected academic year
          </Text>
        </div>

   

        {/* =====================================================
            RESPONSIBILITIES
        ====================================================== */}

        <Card
          className="vpi-panel vpi-responsibilities-panel"
          bordered={false}
          styles={{ body: { padding: 0 } }}
          style={{
            background: pageTheme.card,
            border: `1px solid ${pageTheme.border}`,
          }}
        >
          {sectionHeading(
            "YOUR LEADERSHIP MANDATE",
            "Key Responsibilities",
            <SolutionOutlined />,
            COLORS.gold
          )}

          <div className="vpi-responsibility-intro">
            <Paragraph>
              The Vice Principal supports the Principal in implementing
              school policies, supervising academic activities,
              promoting discipline, and ensuring that daily operations
              run effectively. These responsibilities should be carried
              out in accordance with the school's approved policies
              and delegated authority.
            </Paragraph>
          </div>

          <Row gutter={[12, 12]} className="vpi-responsibility-grid">
            {responsibilities.map((item, index) => (
              <Col xs={24} sm={12} xl={8} key={item.number}>
                <motion.div
                  className="vpi-responsibility-card"
                  initial={{ opacity: 0, y: 8 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.28,
                    delay: index * 0.045,
                  }}
                >
                  <div
                    className="vpi-responsibility-icon"
                    style={{
                      color: item.color,
                      background: item.background,
                    }}
                  >
                    {item.icon}
                  </div>

                  <div className="vpi-responsibility-content">
                    <Text className="vpi-responsibility-number">
                      RESPONSIBILITY {item.number}
                    </Text>

                    <Title level={5} className="vpi-responsibility-title">
                      {item.title}
                    </Title>

                    <Paragraph className="vpi-responsibility-description">
                      {item.description}
                    </Paragraph>
                  </div>
                </motion.div>
              </Col>
            ))}
          </Row>

          <div className="vpi-authority-note">
            <SafetyCertificateOutlined />

            <div>
              <Text strong>Professional accountability</Text>
              <Text>
                Maintain accurate records, protect confidential student
                and staff information, document important decisions,
                and escalate serious matters to the Principal according
                to school policy.
              </Text>
            </div>
          </div>
        </Card>

        {/* =====================================================
            DAILY WORKSPACE
        ====================================================== */}

        <Row
          gutter={[14, 14]}
          style={{
            marginTop: 15,
            marginLeft: 0,
            marginRight: 0,
          }}
          align="stretch"
        >
          <Col xs={24} xl={11}>
            <motion.div
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.08, duration: 0.3 }}
              style={{ height: "100%" }}
            >
              <Card
                className="vpi-panel vpi-workspace-panel"
                bordered={false}
                styles={{ body: { padding: 0 } }}
                style={{
                  height: "100%",
                  background: pageTheme.card,
                  border: `1px solid ${pageTheme.border}`,
                }}
              >
                {sectionHeading(
                  "DAILY MANAGEMENT",
                  "Tasks & Priorities",
                  <CheckCircleOutlined />,
                  COLORS.green
                )}

                <div className="vpi-panel-description">
                  <Text>
                    Organize your workload, track follow-ups, and keep
                    important school duties moving forward.
                  </Text>
                </div>

                <Divider
                  style={{
                    margin: "0 0 14px",
                    borderColor: pageTheme.border,
                  }}
                />

    

                <div className="vpi-bottom-note">
                  <ClockCircleOutlined />
                  <span>
                    Review outstanding tasks regularly and follow up
                    on matters requiring action.
                  </span>
                </div>
              </Card>
            </motion.div>
          </Col>

          <Col xs={24} xl={13}>
            <motion.div
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.13, duration: 0.3 }}
              style={{ height: "100%" }}
            >
              <Card
                className="vpi-panel vpi-workspace-panel"
                bordered={false}
                styles={{ body: { padding: 0 } }}
                style={{
                  height: "100%",
                  background: pageTheme.card,
                  border: `1px solid ${pageTheme.border}`,
                }}
              >
                {sectionHeading(
                  "SCHOOL ACTIVITIES",
                  "Calendar & Transactions",
                  <CalendarOutlined />,
                  COLORS.blue
                )}

                <div className="vpi-panel-description">
                  <Text>
                    Keep school activities, scheduled events, and
                    available transaction records within view.
                  </Text>
                </div>

                <Divider
                  style={{
                    margin: "0 0 14px",
                    borderColor: pageTheme.border,
                  }}
                />


                <div className="vpi-bottom-note">
                  <CalendarOutlined />
                  <span>
                    Check upcoming events and coordinate activities
                    with the appropriate school personnel.
                  </span>
                </div>
              </Card>
            </motion.div>
          </Col>
        </Row>

        {/* =====================================================
            DAILY LEADERSHIP CHECKLIST
        ====================================================== */}

        <Card
          className="vpi-panel vpi-checklist-panel"
          bordered={false}
          styles={{ body: { padding: 0 } }}
          style={{
            marginTop: 15,
            background: pageTheme.card,
            border: `1px solid ${pageTheme.border}`,
          }}
        >
          {sectionHeading(
            "A PRACTICAL DAILY ROUTINE",
            "The Vice Principal's Daily Checklist",
            <FlagOutlined />,
            COLORS.gold
          )}

          <div className="vpi-checklist-content">
            <div className="vpi-checklist-grid">
              {dailyPriorities.map((priority, index) => (
                <div className="vpi-checklist-item" key={priority}>
                  <span className="vpi-checklist-number">
                    {String(index + 1).padStart(2, "0")}
                  </span>

                  <span className="vpi-checklist-text">
                    {priority}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="vpi-checklist-footer">
            <div className="vpi-checklist-footer-icon">
              <TrophyOutlined />
            </div>

            <div>
              <Text strong>Lead with fairness and consistency.</Text>
              <Text>
                Prioritize student welfare, instructional quality,
                professional conduct, and timely communication.
              </Text>
            </div>
          </div>
        </Card>

        {/* =====================================================
            ACADEMIC SETUP MODALS
        ====================================================== */}

        <AddClass
          open={openAddClass}
          handleClose={() => setOpenAddClass(false)}
          onClassCreated={triggerAcademicCountUpdate}
        />

        <SubjectFormModal
          open={openSubjectModal}
          handleClose={() => setOpenSubjectModal(false)}
          onSubjectCreated={triggerAcademicCountUpdate}
        />

        <DivisionFormModal
          open={openDivisionModal}
          handleClose={() => setOpenDivisionModal(false)}
          onDivisionCreated={triggerAcademicCountUpdate}
        />
      </motion.div>

      {/* =======================================================
          PAGE STYLING
      ======================================================== */}

      <style>
        {`
          .vpi-dashboard {
            --vpi-navy: ${COLORS.navy};
            --vpi-gold: ${COLORS.gold};
            --vpi-card: ${pageTheme.card};
            --vpi-text: ${pageTheme.text};
            --vpi-muted: ${pageTheme.secondary};
            --vpi-border: ${pageTheme.border};
          }

          .vpi-dashboard,
          .vpi-dashboard * {
            box-sizing: border-box;
          }

          .vpi-dashboard .ant-typography {
            color: inherit;
          }

          .vpi-main-card,
          .vpi-panel {
            border-radius: 16px !important;
            overflow: hidden;
            box-shadow: ${
              isDark
                ? "0 5px 20px rgba(0,0,0,.13)"
                : "0 5px 22px rgba(6,42,75,.045)"
            };
          }

          .vpi-header {
            position: relative;
            isolation: isolate;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 24px;
            min-height: 205px;
            padding: 27px 27px 23px;
            color: #fff;
            background:
              radial-gradient(
                circle at 85% 5%,
                rgba(201,154,53,.23),
                transparent 31%
              ),
              linear-gradient(
                118deg,
                ${COLORS.navyDeep} 0%,
                ${COLORS.navy} 57%,
                #10496E 100%
              );
          }

          .vpi-header-decoration {
            position: absolute;
            z-index: -1;
            pointer-events: none;
            border-radius: 50%;
            border: 1px solid rgba(255,255,255,.09);
          }

          .vpi-decoration-one {
            width: 300px;
            height: 300px;
            right: -100px;
            top: -170px;
            box-shadow:
              0 0 0 26px rgba(255,255,255,.025),
              0 0 0 52px rgba(255,255,255,.018);
          }

          .vpi-decoration-two {
            width: 170px;
            height: 170px;
            right: 18%;
            bottom: -130px;
            border-color: rgba(201,154,53,.24);
          }

          .vpi-header-top {
            display: flex;
            align-items: center;
            gap: 19px;
            min-width: 0;
            flex: 1 1 auto;
          }

          .vpi-profile {
            flex: 0 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 0;
            padding: 5px;
            border: 1px solid rgba(255,255,255,.25);
            border-radius: 15px;
            background: rgba(255,255,255,.10);
            backdrop-filter: blur(8px);
          }

          .vpi-heading {
            min-width: 0;
            max-width: 700px;
          }

          .vpi-eyebrow {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 8px;
            margin-bottom: 9px;
            color: #E8CC88;
            font-size: 10px;
            line-height: 1.5;
            font-weight: 800;
            letter-spacing: 1.4px;
            text-transform: uppercase;
          }

          .vpi-title {
            margin: 0 0 9px !important;
            color: #FFFFFF !important;
            font-size: clamp(23px, 2.3vw, 33px) !important;
            line-height: 1.2 !important;
            font-weight: 850 !important;
            letter-spacing: -.65px;
          }

          .vpi-subtitle {
            max-width: 590px;
            margin: 0 0 13px !important;
            color: rgba(255,255,255,.77) !important;
            font-size: 12px;
            line-height: 1.8;
          }

          .vpi-leadership-tags {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 7px;
          }

          .vpi-role-tag,
          .vpi-office-tag {
            margin: 0 !important;
            border-radius: 6px !important;
            padding: 4px 9px !important;
            font-size: 9px !important;
            line-height: 1.5 !important;
            font-weight: 800;
            letter-spacing: .45px;
          }

          .vpi-role-tag {
            color: #F6D98F !important;
            background: rgba(201,154,53,.16) !important;
            border: 1px solid rgba(235,198,112,.35) !important;
          }

          .vpi-role-tag .anticon {
            margin-right: 4px;
          }

          .vpi-office-tag {
            color: rgba(255,255,255,.86) !important;
            background: rgba(255,255,255,.07) !important;
            border: 1px solid rgba(255,255,255,.15) !important;
          }

          .vpi-header-controls {
            position: relative;
            z-index: 2;
            display: flex;
            flex: 0 0 auto;
            flex-direction: column;
            align-items: stretch;
            gap: 13px;
            min-width: 195px;
            padding: 15px;
            border: 1px solid rgba(255,255,255,.17);
            border-radius: 12px;
            background: rgba(2,19,35,.26);
            backdrop-filter: blur(8px);
          }

          .vpi-year-control {
            display: flex;
            flex-direction: column;
            gap: 7px;
            min-width: 0;
          }

          .vpi-control-label {
            color: #E8CC88 !important;
            font-size: 9px;
            font-weight: 800;
            letter-spacing: 1px;
          }

          .vpi-year-control > *:last-child {
            min-width: 0;
            max-width: 100%;
          }

          .vpi-year-control .ant-select-selector {
            border-radius: 7px !important;
          }

          .vpi-add-button {
            width: 100%;
            height: 38px !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 7px;
            border-radius: 7px !important;
            color: ${COLORS.navy} !important;
            background: #E6C36F !important;
            border-color: #E6C36F !important;
            box-shadow: none !important;
            font-size: 11px !important;
            font-weight: 800 !important;
          }

          .vpi-add-button:hover {
            color: ${COLORS.navyDeep} !important;
            background: #F1D99D !important;
            border-color: #F1D99D !important;
          }

          .vpi-header-footer {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            gap: 12px;
            padding: 14px 25px;
            background: ${
              isDark ? "#182A3C" : "#FBF8F0"
            };
            border-top: 1px solid ${
              isDark ? pageTheme.border : "#F0E6CE"
            };
          }

          .vpi-footer-message {
            display: flex;
            align-items: center;
            gap: 11px;
            min-width: 0;
          }

          .vpi-footer-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 34px;
            height: 34px;
            flex: 0 0 34px;
            border-radius: 9px;
            color: ${COLORS.gold};
            background: ${
              isDark ? "#26374A" : "#F1E7CE"
            };
            font-size: 15px;
          }

          .vpi-footer-message > span:last-child {
            display: flex;
            flex-direction: column;
            gap: 3px;
            min-width: 0;
          }

          .vpi-footer-message strong {
            color: ${pageTheme.text};
            font-size: 11px;
            font-weight: 800;
          }

          .vpi-footer-message > span:last-child > span {
            color: ${pageTheme.secondary};
            font-size: 10px;
            line-height: 1.6;
          }

          .vpi-footer-mark {
            display: flex;
            align-items: center;
            gap: 7px;
            color: ${COLORS.gold};
            font-size: 10px;
            font-weight: 800;
            letter-spacing: .2px;
          }

          .vpi-block-heading {
            display: flex;
            align-items: flex-end;
            justify-content: space-between;
            flex-wrap: wrap;
            gap: 8px;
            margin: 24px 2px 13px;
          }

          .vpi-section-eyebrow {
            display: block;
            margin-bottom: 5px;
            color: ${pageTheme.secondary} !important;
            font-size: 9px;
            line-height: 1.4;
            font-weight: 800;
            letter-spacing: 1.1px;
            text-transform: uppercase;
          }

          .vpi-block-title {
            margin: 0 !important;
            color: ${pageTheme.text} !important;
            font-size: 19px !important;
            line-height: 1.3 !important;
            font-weight: 850 !important;
          }

          .vpi-block-caption {
            color: ${pageTheme.secondary} !important;
            font-size: 10px;
          }

          .vpi-stat-col {
            padding-left: 7px !important;
            padding-right: 7px !important;
            min-width: 0;
          }

          .vpi-stat-col > * {
            height: 100%;
          }

          .vpi-panel {
            margin-top: 15px;
          }

          .vpi-section-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            padding: 19px 20px 15px;
            border-bottom: 1px solid ${pageTheme.border};
          }

          .vpi-section-title {
            margin: 0 !important;
            color: ${pageTheme.text} !important;
            font-size: 18px !important;
            line-height: 1.35 !important;
            font-weight: 850 !important;
          }

          .vpi-section-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 0 0 39px;
            width: 39px;
            height: 39px;
            border-radius: 11px;
            font-size: 17px;
          }

          .vpi-responsibility-intro {
            padding: 15px 20px 2px;
          }

          .vpi-responsibility-intro .ant-typography {
            max-width: 900px;
            margin: 0;
            color: ${pageTheme.secondary};
            font-size: 11px;
            line-height: 1.85;
          }

          .vpi-responsibility-grid {
            padding: 12px 13px 18px;
            margin: 0 !important;
          }

          .vpi-responsibility-grid > .ant-col {
            padding-left: 7px !important;
            padding-right: 7px !important;
          }

          .vpi-responsibility-card {
            display: flex;
            align-items: flex-start;
            gap: 12px;
            height: 100%;
            min-height: 142px;
            padding: 17px 14px;
            border: 1px solid ${pageTheme.border};
            border-radius: 11px;
            background: ${
              isDark ? "#192A3B" : "#FFFFFF"
            };
            transition:
              border-color .2s ease,
              transform .2s ease,
              box-shadow .2s ease;
          }

          .vpi-responsibility-card:hover {
            transform: translateY(-2px);
            border-color: rgba(201,154,53,.58);
            box-shadow: 0 7px 18px rgba(6,42,75,.055);
          }

          .vpi-responsibility-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 38px;
            height: 38px;
            flex: 0 0 38px;
            border-radius: 10px;
            font-size: 17px;
          }

          .vpi-responsibility-content {
            min-width: 0;
            flex: 1;
          }

          .vpi-responsibility-number {
            display: block;
            margin-bottom: 6px;
            color: ${pageTheme.secondary} !important;
            font-size: 8px;
            font-weight: 800;
            letter-spacing: .75px;
          }

          .vpi-responsibility-title {
            margin: 0 0 7px !important;
            color: ${pageTheme.text} !important;
            font-size: 13px !important;
            line-height: 1.45 !important;
            font-weight: 800 !important;
          }

          .vpi-responsibility-description {
            margin: 0 !important;
            color: ${pageTheme.secondary} !important;
            font-size: 10px;
            line-height: 1.8;
          }

          .vpi-authority-note {
            display: flex;
            align-items: flex-start;
            gap: 12px;
            margin: 0 20px 20px;
            padding: 14px 15px;
            border: 1px solid ${
              isDark ? "#4C422B" : "#F0E1BC"
            };
            border-radius: 10px;
            color: ${COLORS.gold};
            background: ${
              isDark ? "#2A281F" : "#FCF8ED"
            };
            font-size: 16px;
          }

          .vpi-authority-note > .anticon {
            margin-top: 2px;
            flex: 0 0 auto;
          }

          .vpi-authority-note > div {
            display: flex;
            flex-direction: column;
            gap: 5px;
            min-width: 0;
          }

          .vpi-authority-note .ant-typography:first-child {
            color: ${pageTheme.text};
            font-size: 11px;
          }

          .vpi-authority-note .ant-typography:last-child {
            color: ${pageTheme.secondary};
            font-size: 10px;
            line-height: 1.8;
          }

          .vpi-workspace-panel {
            height: 100%;
          }

          .vpi-panel-description {
            padding: 13px 20px 15px;
          }

          .vpi-panel-description .ant-typography {
            color: ${pageTheme.secondary};
            font-size: 10px;
            line-height: 1.8;
          }

          .vpi-panel-inner {
            padding: 0 15px 15px;
            min-width: 0;
          }

          .vpi-bottom-note {
            display: flex;
            align-items: flex-start;
            gap: 9px;
            margin: 0 15px 15px;
            padding: 11px 12px;
            border-radius: 8px;
            color: ${pageTheme.secondary};
            background: ${
              isDark ? "#1B2B3D" : "#F5F8FB"
            };
            font-size: 10px;
            line-height: 1.7;
          }

          .vpi-bottom-note .anticon {
            margin-top: 2px;
            flex: 0 0 auto;
            color: ${COLORS.gold};
          }

          .vpi-checklist-content {
            padding: 17px 20px 20px;
          }

          .vpi-checklist-grid {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 11px;
          }

          .vpi-checklist-item {
            display: flex;
            align-items: center;
            gap: 12px;
            min-width: 0;
            min-height: 57px;
            padding: 11px 13px;
            border: 1px solid ${pageTheme.border};
            border-radius: 9px;
            background: ${
              isDark ? "#192A3B" : "#FFFFFF"
            };
          }

          .vpi-checklist-number {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 31px;
            height: 31px;
            flex: 0 0 31px;
            border-radius: 8px;
            color: ${COLORS.navy};
            background: ${
              isDark ? "#4A412C" : "#F5ECD8"
            };
            font-size: 10px;
            font-weight: 850;
          }

          .vpi-checklist-text {
            min-width: 0;
            color: ${pageTheme.text};
            font-size: 10px;
            font-weight: 600;
            line-height: 1.7;
          }

          .vpi-checklist-footer {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 17px 20px;
            border-top: 1px solid ${
              isDark ? pageTheme.border : "#EDE3CF"
            };
            background: ${
              isDark ? "#1C2A39" : "#FBF8F1"
            };
          }

          .vpi-checklist-footer-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 0 0 36px;
            width: 36px;
            height: 36px;
            border-radius: 10px;
            color: ${COLORS.gold};
            background: ${
              isDark ? "#342F23" : "#F1E5C8"
            };
            font-size: 16px;
          }

          .vpi-checklist-footer > div:last-child {
            display: flex;
            flex-direction: column;
            gap: 4px;
            min-width: 0;
          }

          .vpi-checklist-footer .ant-typography:first-child {
            color: ${pageTheme.text};
            font-size: 11px;
          }

          .vpi-checklist-footer .ant-typography:last-child {
            color: ${pageTheme.secondary};
            font-size: 10px;
            line-height: 1.7;
          }

          @media (min-width: 1400px) {
            .vpi-responsibility-card {
              padding: 19px 17px;
            }

            .vpi-responsibility-description {
              font-size: 10.5px;
            }
          }

          @media (max-width: 1100px) {
            .vpi-header {
              align-items: flex-start;
              flex-direction: column;
              gap: 20px;
            }

            .vpi-header-top {
              width: 100%;
            }

            .vpi-header-controls {
              width: 100%;
              flex-direction: row;
              align-items: flex-end;
              justify-content: space-between;
            }

            .vpi-year-control {
              flex: 1;
              max-width: 300px;
            }

            .vpi-add-button {
              width: auto;
              min-width: 145px;
            }
          }

          @media (max-width: 767px) {
            .vpi-header {
              padding: 20px 16px;
              min-height: auto;
            }

            .vpi-header-top {
              align-items: flex-start;
              gap: 13px;
            }

            .vpi-profile {
              padding: 3px;
              border-radius: 10px;
            }

            .vpi-title {
              font-size: 23px !important;
              letter-spacing: -.35px;
            }

            .vpi-subtitle {
              font-size: 11px;
              line-height: 1.75;
            }

            .vpi-eyebrow {
              font-size: 9px;
              letter-spacing: .85px;
            }

            .vpi-header-controls {
              gap: 10px;
              padding: 11px;
            }

            .vpi-add-button {
              min-width: 125px;
              padding: 0 10px !important;
              font-size: 10px !important;
            }

            .vpi-header-footer {
              padding: 13px 15px;
            }

            .vpi-footer-mark {
              display: none;
            }

            .vpi-block-heading {
              margin-top: 21px;
            }

            .vpi-section-header {
              padding: 16px 15px 13px;
            }

            .vpi-section-title {
              font-size: 16px !important;
            }

            .vpi-responsibility-intro {
              padding: 13px 15px 0;
            }

            .vpi-responsibility-grid {
              padding: 12px 8px 15px;
            }

            .vpi-authority-note {
              margin: 0 14px 15px;
            }

            .vpi-checklist-content {
              padding: 14px;
            }

            .vpi-checklist-grid {
              grid-template-columns: 1fr;
            }

            .vpi-checklist-footer {
              padding: 14px;
            }
          }

          @media (max-width: 460px) {
            .vpi-header {
              padding: 16px 12px;
              gap: 16px;
            }

            .vpi-header-top {
              gap: 10px;
            }

            .vpi-title {
              font-size: 20px !important;
              line-height: 1.25 !important;
            }

            .vpi-eyebrow {
              font-size: 8px;
              line-height: 1.7;
            }

            .vpi-subtitle {
              font-size: 10px;
            }

            .vpi-role-tag,
            .vpi-office-tag {
              font-size: 8px !important;
            }

            .vpi-header-controls {
              flex-direction: column;
              align-items: stretch;
            }

            .vpi-year-control {
              max-width: none;
              width: 100%;
            }

            .vpi-add-button {
              width: 100%;
            }

            .vpi-header-footer {
              padding: 12px;
            }

            .vpi-footer-message {
              align-items: flex-start;
              gap: 9px;
            }

            .vpi-footer-message > span:last-child > span {
              font-size: 9px;
            }

            .vpi-block-title {
              font-size: 17px !important;
            }

            .vpi-block-caption {
              font-size: 9px;
            }

            .vpi-section-icon {
              width: 34px;
              height: 34px;
              flex-basis: 34px;
              font-size: 15px;
            }

            .vpi-responsibility-card {
              min-height: auto;
              padding: 14px 12px;
              gap: 10px;
            }

            .vpi-responsibility-icon {
              width: 34px;
              height: 34px;
              flex-basis: 34px;
              font-size: 15px;
            }

            .vpi-responsibility-title {
              font-size: 12px !important;
            }

            .vpi-responsibility-description {
              font-size: 10px;
            }

            .vpi-panel-inner {
              padding: 0 10px 12px;
            }

            .vpi-bottom-note {
              margin: 0 10px 12px;
            }

            .vpi-checklist-text {
              font-size: 10px;
            }
          }

          @media (prefers-reduced-motion: reduce) {
            .vpi-dashboard *,
            .vpi-dashboard *::before,
            .vpi-dashboard *::after {
              animation-duration: .01ms !important;
              transition-duration: .01ms !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default OverviewVpi;
